var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8817 7.12871C10.565 7.12871 10.3091 7.38533 10.3091 7.7014V12.2832C10.3091 12.5988 10.0524 12.8559 9.73637 12.8559H1.71818C1.402 12.8559 1.14549 12.5988 1.14549 12.2832V4.26505C1.14549 3.9495 1.402 3.69236 1.71818 3.69236H6.30002C6.61672 3.69236 6.87271 3.43575 6.87271 3.11967C6.87271 2.80349 6.61672 2.54688 6.30002 2.54688H1.71818C0.770893 2.54688 0 3.31777 0 4.26505V12.2832C0 13.2305 0.770893 14.0014 1.71818 14.0014H9.73637C10.6837 14.0014 11.4545 13.2305 11.4545 12.2832V7.7014C11.4545 7.3847 11.1985 7.12871 10.8817 7.12871Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61976 6.1852C5.57634 6.22862 5.54713 6.28387 5.53474 6.34343L5.09589 8.53866C5.07543 8.6404 5.10771 8.74532 5.18091 8.8192C5.2399 8.8782 5.31935 8.9098 5.40073 8.9098C5.42051 8.9098 5.44108 8.90798 5.46154 8.90366L7.65592 8.46478C7.71673 8.45227 7.77197 8.42317 7.81482 8.37964L12.7262 3.46787L10.5318 1.27344L5.61976 6.1852Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6688 0.329444C13.2297 -0.109815 12.5153 -0.109815 12.0765 0.329444L11.4531 0.952903L13.0455 2.54545L13.6688 1.92191C13.8815 1.70975 13.9986 1.42681 13.9986 1.12588C13.9986 0.824961 13.8815 0.542021 13.6688 0.329444Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.7c3b46f132328d305c0bd878a7f5235e.svg";
export { ForwardRef as ReactComponent };